import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';

const ProjectTableRow = ({ project, returnPath }) => {

  const item = { ...project.attributes };
  const projectDate = moment(item.launchDate).format("YYYY-MM-DD");

  return (
    <tr>
      <td>{projectDate}</td>
      <td>{item.projectNumber}</td>
      <td>{item.projectName}</td>
      <td>{item.complexity}</td>
      <td>{item.companyName}</td>
      <td>{item.projectType}</td>
      <td className="table-buttons">
        <Link to={{ pathname: `/projects/${project.id}/summary`, state: { returnPath } }} data-icon="&#xe900;" data-tooltip="Schedule">schedule</Link>
        <Link to={{ pathname: `/projects/${project.id}/edit`, state: { returnPath } }} className="edit" data-icon="&#xe909;" data-tooltip="Edit">edit</Link>
      </td>
    </tr>
  );
};

ProjectTableRow.propTypes = {
  project: PropTypes.object.isRequired
};

export default ProjectTableRow;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectTableRow.js